import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import OrganisationCredits from './organisationCredits';
import { bindActionCreators } from 'redux';
import * as snackbarsActions from '../../actions/snackbars';
import * as subscriptionActions from '../../actions/subscription';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const OrganisationView = _ref => {
  let {
    actions,
    organisation
  } = _ref;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [organisation && /*#__PURE__*/_jsx("div", {
      className: "flex-container space-between",
      children: /*#__PURE__*/_jsx("div", {
        className: "mb-5",
        children: /*#__PURE__*/_jsx("h1", {
          "data-id": "request-title",
          className: "ml-6 mb-0",
          children: organisation.fullName
        })
      })
    }), /*#__PURE__*/_jsx(OrganisationCredits, {
      organisation: organisation,
      actions: actions
    })]
  });
};
OrganisationView.propTypes = {
  organisation: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  return {
    organisation: state.organisation
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      ...snackbarsActions,
      ...subscriptionActions
    }, dispatch)
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(OrganisationView);